import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WrongLocationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wrong_location"}/>
}
